
import { Component, OnInit } from '@angular/core';
import { LoadingService } from './@core/services/local/loading.service';
import { LookupService } from './@core/services/lookup.service';

@Component({
  selector: 'ngx-app',
  templateUrl: 'app.component.html',
  styleUrls : ['app.component.css']
})
export class AppComponent implements OnInit {

  constructor(public loadingService:LoadingService, private lookupService:LookupService) {
   
  }

  ngOnInit(): void {
    this.getTaxOffices();
  }
  private getTaxOffices() {
   this.lookupService.getTaxOffices().then(data=> {
     this.lookupService.TaxOffices = data;
   })
  }
}
